import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { routes } from '@lean-body/src/route';
import { useNavigate } from 'react-router-dom';
import { isWithinDaysFromToday, ONE_DAY_IN_MS } from '@lean-body/src/util';
import { Colors, MediaBreakPointUp } from '@lean-body/components/styles';
import { ArrowDirection, ArrowIconWithMargin } from '../atoms';
import { LocalStorage } from '@lean-body/src/infra';
import { ZIndex } from '../constants';
import { CLOSE_ROUND_ICON_DARk_GARY, CloseRoundIcon } from '../atoms/icons/close_round_icon';
const MONTHLY_PLAN_DISPLAY_DAYS = 7;
const ANNUAL_PLAN_DISPLAY_DAYS = 30;
export const CancelUnsubscribeBanner = ({ me, tracker }) => {
    const navigate = useNavigate();
    const localStorage = new LocalStorage();
    const displayDays = (me === null || me === void 0 ? void 0 : me.payment.currentPlan.isAnnualPlan()) ? ANNUAL_PLAN_DISPLAY_DAYS : MONTHLY_PLAN_DISPLAY_DAYS;
    // 退会予定日が30日(年間プラン)or7日(月額プラン)以内である、かつ前回表示から24時間以上経っている場合にバナーを表示
    const initIsDisplay = (me === null || me === void 0 ? void 0 : me.unsubscribeScheduledAt) &&
        isWithinDaysFromToday(me.payment.curPeriodEndDate, displayDays) &&
        localStorage.loadDeletedAtCancelUnsubscribeBanner < Date.now() - ONE_DAY_IN_MS;
    const [isDisplay, setIsDisplay] = React.useState(initIsDisplay);
    const onClick = () => {
        tracker.trackCancelUnsubscribeBannerClick();
        navigate(routes.PLAN_CHANGE_UNSUBSCRIBE_CP.compile());
    };
    const onClickCloseIcon = () => {
        setIsDisplay(false);
        localStorage.setDeletedAtCancelUnsubscribeBanner(Date.now());
    };
    return (React.createElement(React.Fragment, null, isDisplay && (React.createElement("div", { className: css(styles.container) },
        React.createElement(CloseRoundIcon, { color: CLOSE_ROUND_ICON_DARk_GARY, size: 25, onClick: onClickCloseIcon, classObject: styles.closeIcon }),
        React.createElement("div", { className: css(styles.bannerText) },
            React.createElement("div", { className: css(styles.bannerTitle) }, "\uD83C\uDF81 \u7279\u5225\u30AA\u30D5\u30A1\u30FC"),
            React.createElement("div", { className: css(styles.bannerDiscription) },
                "\u9000\u4F1A\u524D\u306E\u65B9\u3060\u3051\u306E",
                React.createElement("br", null),
                "\u5272\u5F15\u30D7\u30E9\u30F3\u3092\u3054\u7528\u610F\u3057\u3066\u3044\u307E\u3059")),
        React.createElement("div", { className: css(styles.bannerButton), onClick: onClick },
            React.createElement("div", { className: css(styles.buttonText) }, "\u7279\u5178\u3092\u53D7\u3051\u53D6\u308B"),
            React.createElement(ArrowIconWithMargin, { direction: ArrowDirection.right, color: Colors.Accent, classObject: styles.arrowIcon }))))));
};
const styles = StyleSheet.create({
    container: {
        display: 'flex',
        alignItems: 'center',
        color: Colors.White,
        backgroundColor: Colors.Accent,
        gap: 10,
        fontWeight: 'bold',
        width: '100%',
        padding: '10px 12px',
        [MediaBreakPointUp.XL]: {
            position: 'fixed',
            width: 383,
            bottom: 42,
            right: 26,
            borderRadius: 10,
            boxShadow: '0 4px 16px 0 rgba(0, 0, 0, 0.20)',
            zIndex: ZIndex.HomePositionFixed,
        },
    },
    closeIcon: {
        [MediaBreakPointUp.XL]: {
            position: 'absolute',
            top: -17,
        },
    },
    bannerText: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        gap: 6,
    },
    bannerTitle: {
        fontSize: 15,
        lineHeight: '100%',
    },
    bannerDiscription: {
        fontSize: 12,
        lineHeight: '140%',
        letterSpacing: 0.3,
    },
    bannerButton: {
        color: Colors.Accent,
        backgroundColor: Colors.White,
        display: 'flex',
        alignItems: 'center',
        padding: '10px 10px 10px 12px',
        borderRadius: 20,
        cursor: 'pointer',
    },
    buttonText: {
        fontSize: 13,
        lineHeight: '160%',
        letterSpacing: 0.88,
    },
    arrowIcon: {
        width: 20,
        height: 20,
    },
});
